import type { WorkflowConditionConditionType } from '@/api/entity_types/workflow/WorkflowCondition';
import { useCurrentWorkflowStore } from '@/stores/workflow/currentWorkflow';

export const useConditionDisplay = () => {
  const store = useCurrentWorkflowStore();
  const triggerType = store.currentDefinition.trigger.name.toLowerCase();

  const filterConditionDisplay = {
    capital: 'Filter',
    capitalPlural: 'Filters',
    lowercase: 'filter',
    lowercasePlural: 'filters',
    description: `A filter determines whether or not the ${triggerType} trigger will invoke the actions. Without a filter, the trigger will always invoke the actions`,
  } as const;

  const exitCriteriaConditionDisplay = {
    capital: 'Exit Criteria',
    capitalPlural: 'Exit Criteria',
    lowercase: 'exit criteria',
    lowercasePlural: 'exit criteria',
    description:
      'Exit criteria control whether scheduled actions continue or are canceled. Without exit criteria, the scheduled actions will continue until the sequence is finished.',
  } as const;

  const conditionDisplay = (condition: WorkflowConditionConditionType) => {
    if (condition === 'filter') return filterConditionDisplay;
    else return exitCriteriaConditionDisplay;
  };

  return { conditionDisplay };
};
